"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVE_PARTNER_SUPPORT_TICKET_CATEGORIES = exports.PartnerSupportTicketCategory = void 0;
/** Full persisted domain for partner support ticket categories. */
/** @TranslateToPython */
var PartnerSupportTicketCategory;
(function (PartnerSupportTicketCategory) {
    PartnerSupportTicketCategory["INCORRECT_APPLICANT_DETAILS"] = "INCORRECT_APPLICANT_DETAILS";
    PartnerSupportTicketCategory["OFFERS_AND_UNDERWRITING"] = "OFFERS_AND_UNDERWRITING";
    PartnerSupportTicketCategory["DENIAL_REVIEW"] = "DENIAL_REVIEW";
    PartnerSupportTicketCategory["INCOME_VERIFICATION"] = "INCOME_VERIFICATION";
    PartnerSupportTicketCategory["BANK_CONNECTION"] = "BANK_CONNECTION";
    PartnerSupportTicketCategory["NOTARY_AND_CLOSING"] = "NOTARY_AND_CLOSING";
    PartnerSupportTicketCategory["IDENTITY_VERIFICATION"] = "IDENTITY_VERIFICATION";
    PartnerSupportTicketCategory["CONDITIONS"] = "CONDITIONS";
    PartnerSupportTicketCategory["LICENSING"] = "LICENSING";
    PartnerSupportTicketCategory["OTHER"] = "OTHER";
    /** @deprecated Use CONDITIONS. */
    PartnerSupportTicketCategory["POST_CLOSE_CONDITIONS_AND_FUNDING"] = "POST_CLOSE_CONDITIONS_AND_FUNDING";
    /** @deprecated Use INCOME_VERIFICATION or BANK_CONNECTION. */
    PartnerSupportTicketCategory["INCOME_AND_BANK_VERIFICATION"] = "INCOME_AND_BANK_VERIFICATION";
    /** @deprecated Use INCORRECT_APPLICANT_DETAILS. */
    PartnerSupportTicketCategory["APPLICATION_CHANGES"] = "APPLICATION_CHANGES";
    /** @deprecated No replacement. */
    PartnerSupportTicketCategory["APPLICATION_ERROR"] = "APPLICATION_ERROR";
    /** @deprecated No replacement. */
    PartnerSupportTicketCategory["STATUS_UPDATES"] = "STATUS_UPDATES";
})(PartnerSupportTicketCategory || (exports.PartnerSupportTicketCategory = PartnerSupportTicketCategory = {}));
/** Selectable categories, in display order. */
/** @TranslateToPython */
exports.ACTIVE_PARTNER_SUPPORT_TICKET_CATEGORIES = [
    PartnerSupportTicketCategory.INCORRECT_APPLICANT_DETAILS,
    PartnerSupportTicketCategory.OFFERS_AND_UNDERWRITING,
    PartnerSupportTicketCategory.DENIAL_REVIEW,
    PartnerSupportTicketCategory.INCOME_VERIFICATION,
    PartnerSupportTicketCategory.BANK_CONNECTION,
    PartnerSupportTicketCategory.NOTARY_AND_CLOSING,
    PartnerSupportTicketCategory.IDENTITY_VERIFICATION,
    PartnerSupportTicketCategory.CONDITIONS,
    PartnerSupportTicketCategory.LICENSING,
    PartnerSupportTicketCategory.OTHER,
];
